package com.neurobs.ccabserver.translation

import com.neurobs.ccab.IdentityData
import com.neurobs.react.semanticui.UiGridFactory
import com.neurobs.ccabserver.translation.components.engineselection.EngineSelection
import com.neurobs.ccabserver.translation.components.phraseselection.{PhraseGroupSelection, PhraseSelection}
import com.neurobs.ccabserver.translation.components.phrasetranslation.PhraseTranslation
import com.neurobs.ccabserver.translation.components.translationreplacement.TranslationReplacement
import com.neurobs.ccabserver.translation.components.translatorselection.{OtherUserSelection, TranslatorSelection}
import com.neurobs.ccabserver.translation.states.{EngineSelectionStateProvider, PhraseGroupSelectionStateProvider, PhraseSelectionStateProvider, PhraseTranslationStateProvider, TranslationSubSearchStateProvider, TranslatorStateProvider}
import com.neurobs.js.ccab.{RelativeJSCCABServer, ServerContext}
import org.scalajs.dom
import org.scalajs.dom.raw.Element
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.web.ReactDOM
import slinky.web.html._

import scala.scalajs.js

class Main(targetDiv: Element, userData: IdentityData) {

  ReactDOM.render(
    TranslationTool(userData),
	  targetDiv
  )

}

@react
object TranslationTool {

  case class Props(userData: IdentityData)

  val component = FunctionalComponent[Props] { props =>

    val appHtml = UiGridFactory.Grid(
      OtherUserSelection(
        enclosingElement = UiGridFactory.GridColumn(_)("sixteen wide")
      ),
      TranslatorSelection(
        enclosingElement = UiGridFactory.GridColumn(_)("sixteen wide")
      ),
      //      EngineSelection(
      //        enclosingElement = GridFactory.GridColumn(_)("sixteen wide")
      //      ),
      PhraseGroupSelection(
        enclosingElement = UiGridFactory.GridColumn(_)("four wide center aligned")
      ),
      PhraseSelection(
        enclosingElement = UiGridFactory.GridColumn(_)("twelve wide center aligned")
      ),
      PhraseTranslation(
        enclosingElement = UiGridFactory.GridColumn(_)("sixteen wide")
      ),
      TranslationReplacement(
        enclosingElement = UiGridFactory.GridColumn(_)(("sixteen wide center aligned", Seq[(String, js.Any)](("borderTop", "3px solid #FFFFFF"))))
      )
    )("bottom aligned")

    TranslatorStateProvider(props.userData)(
		 ServerContext.provider(RelativeJSCCABServer())(
      EngineSelectionStateProvider(
        PhraseGroupSelectionStateProvider(
          PhraseSelectionStateProvider(
            PhraseTranslationStateProvider(
              TranslationSubSearchStateProvider(
                appHtml
              )
            )
          )
        )
      )
		 )
    )
  }
}

